"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegisterConfig = void 0;
var _Register = _interopRequireDefault(require("./Register"));
var _RegisterSuccess = _interopRequireDefault(require("./RegisterSuccess"));
var _RegisterActions = require("./RegisterActions");
var _RegisterReducer = _interopRequireDefault(require("./RegisterReducer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var RegisterConfig = {
  auth: ['guest'],
  routes: [{
    component: _Register.default,
    path: '/register'
  }, {
    component: _RegisterSuccess.default,
    path: '/register-success'
  }],
  settings: {
    layout: {
      config: {
        footer: {
          display: false
        },
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        }
      }
    }
  },
  reducer: _RegisterReducer.default,
  actions: _RegisterActions.registerSaga
};
exports.RegisterConfig = RegisterConfig;